export const SITE = {
  name: "BM MECHANICS",
  baseline: "Atelier de mécanique indépendant",
  phoneDisplay: "077 926 23 45",
  phoneHref: "tel:+41779262345",
  email: "bm.mecanics@gmail.com",
  emailHref: "mailto:bm.mecanics@gmail.com",
  address: "Route de Cossonay 60",
  addressNpa: "1008 Prilly",
  location: "Prilly · Ouest lausannois · Canton de Vaud",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=Route+de+Cossonay+60%2C+1008+Prilly%2C+Suisse",
  mapsEmbed:
    "https://www.google.com/maps?q=Route%20de%20Cossonay%2060%2C%201008%20Prilly%2C%20Suisse&output=embed",
};

export const NAV = [
  { to: "/", label: "Accueil", testid: "nav-accueil" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/realisations", label: "Réalisations", testid: "nav-realisations" },
  { to: "/a-propos", label: "À propos", testid: "nav-a-propos" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const IMAGES = {
  hero: "/vitrine-auto.jpg",
  vitrineMoto: "/vitrine-moto.jpg",
  vitrineAutoFace: "/vitrine-auto-face.jpg",
  atelierReel: "/atelier-reel.jpg",
  bench: "https://images.unsplash.com/photo-1477333183135-292dd5b3910f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxjYXIlMjByZXBhaXIlMjB3b3Jrc2hvcCUyMG1lY2hhbmljJTIwdG9vbHMlMjB2ZWhpY2xlJTIwbWFpbnRlbmFuY2UlMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3ODg3MDQ5MTZ8MA&ixlib=rb-4.1.0&q=85",
  lift: "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjYXIlMjByZXBhaXIlMjB3b3Jrc2hvcCUyMG1lY2hhbmljJTIwdG9vbHMlMjB2ZWhpY2xlJTIwbWFpbnRlbmFuY2UlMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3ODg3MDQ5MTZ8MA&ixlib=rb-4.1.0&q=85",
  engine: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjYXIlMjBtZWNoYW5pYyUyMHdvcmtpbmclMjBlbmdpbmUlMjByZXBhaXIlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODg3MDQ5MjF8MA&ixlib=rb-4.1.0&q=85",
  moto: "https://images.unsplash.com/photo-1636761358757-0a616eb9e17e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwbWVjaGFuaWMlMjB3b3Jrc2hvcCUyMHJlcGFpcnxlbnwwfHx8fDE3ODg3MDQ5MjF8MA&ixlib=rb-4.1.0&q=85",
  scooter: "https://images.pexels.com/photos/12741656/pexels-photo-12741656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  motoEngine: "https://images.pexels.com/photos/11890959/pexels-photo-11890959.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  motoLift: "https://images.unsplash.com/photo-1604260324056-45f7c778754a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtb3RvcmN5Y2xlJTIwbWVjaGFuaWMlMjB3b3Jrc2hvcCUyMHJlcGFpcnxlbnwwfHx8fDE3ODg3MDQ5MjF8MA&ixlib=rb-4.1.0&q=85",
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function toYoutubeEmbed(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}
